import { css } from "@emotion/react";

import {
  fixedWidth,
  mediaQueryIsDesktop,
  mediaQueryIsMobile,
} from "~/lib/client/design";

export const responseModalContentRootDesignStyle = css`
  ${mediaQueryIsMobile(css`
    width: 95vw;
    padding-bottom: 1rem;
  `)};

  ${mediaQueryIsDesktop(css`
    ${fixedWidth("40rem")}
  `)};
`;
